import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { merchantShape } from '../../utils/propTypes';
import { connect } from 'react-redux';
import {
    toggleSelectorOpen
} from './merchantSelectorActions';
import { getMerchants } from '../Merchants/merchantsActions';
import {
    getIsMerchantsLoading,
    getMerchantsErrorMessage
} from '../Merchants/merchantsEntity';
import {
    closeNavigation
} from '../Navigation/actions';
import { EmvioLoadingSpinner as LoadingSpinner } from '@nexio/emvio-util-ui';
import {
    getIsSelectorOpen,
    getSelectedMerchants
} from './merchantSelectorViewState';
import { toastIfError } from '../../utils/toast';
import './MerchantSelector.scss';
import { getPayoutAccounts } from '../PayoutAccounts/payoutAccountActions';

export class MerchantSelector extends Component {
    static propTypes = {
        error: PropTypes.string,
        isOpen: PropTypes.bool,
        loading: PropTypes.bool,
        onGetMerchants: PropTypes.func.isRequired,
        onGetPayoutAccounts: PropTypes.func.isRequired,
        onToggleSelectorOpen: PropTypes.func.isRequired,
        selectedMerchants: PropTypes.arrayOf(merchantShape)
    };

    static defaultProps = {
        selectedMerchants: []
    };

    constructor(props) {
        super(props);

        this.handleToggleSelector = this.handleToggleSelector.bind(this);
        this.renderSelectorArea = this.renderSelectorArea.bind(this);
        this.renderSelectorText = this.renderSelectorText.bind(this);
    }

    componentDidMount() {
        this.props.onGetMerchants();
        this.props.onGetPayoutAccounts();
    }

    componentDidUpdate(prevProps) {
        toastIfError(prevProps, this.props);
    }

    handleToggleSelector() {
        this.props.onToggleSelectorOpen(!this.props.isOpen, this.props.selectedMerchants);
    }

    renderClickBlocker() {
        if (this.props.isOpen) {
            return (<div className="click-blocker" />);
        }

        return null;
    }

    renderSelectorText(firstMerchant) {
        const selectorText = firstMerchant.name;

        if (this.props.selectedMerchants.length) {
            return (
                <div className="text">
                    {selectorText}
                </div>
            );
        }

        return (
            <div className="text missing-merchants">
                Select Merchants
            </div>
        );
    }

    renderSelectorArea() {
        const firstMerchant = this.props.selectedMerchants[0] || {};
        let numberOfExtraMerchants;

        if (this.props.selectedMerchants.length > 1) {
            numberOfExtraMerchants = `(+${this.props.selectedMerchants.length - 1})`;
        }

        return (
            <div className="selector-area">
                <div className="label-text">
                    CURRENTLY VIEWING
                </div>
                <div className="selector" onClick={this.handleToggleSelector}>
                    <div className="text-wrapper">
                        {this.renderSelectorText(firstMerchant)}
                        {numberOfExtraMerchants
                            ? <div>{numberOfExtraMerchants}</div>
                            : null}
                    </div>
                    <span className="icon-right-caret" />
                </div>
                <div className="merchant-id">
                    {firstMerchant.merchantId}
                </div>
                {this.renderClickBlocker()}
            </div>
        );
    }

    render() {
        return (
            <div className="emvio-merchant-ids">
                {this.props.loading && !this.props.selectedMerchants.length
                    ? <LoadingSpinner invert relative />
                    : this.renderSelectorArea()
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        error: getMerchantsErrorMessage(state),
        isOpen: getIsSelectorOpen(state),
        loading: getIsMerchantsLoading(state),
        selectedMerchants: getSelectedMerchants(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onCloseNavigation: () => dispatch(closeNavigation()),
        onGetMerchants: () => dispatch(getMerchants()),
        onGetPayoutAccounts: () => dispatch(getPayoutAccounts()),
        onToggleSelectorOpen: (isClosed, selectedMerchants) => {
            dispatch(closeNavigation());
            dispatch(toggleSelectorOpen(isClosed, selectedMerchants));
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MerchantSelector);
